import checkPromotionCode from '@/api/subscriptions/checkPromotionCode.endpoint';
import { useState } from 'react';

export default function usePromotionCode({ setPromotionCode }) {
  const [state, setState] = useState({
    promotionCode: '',
    loading: false,
    error: null,
    opened: false,
  });

  const actions = {
    setState: (newState) => {
      setState((previousState) => ({ ...previousState, ...newState }));
    },
    setOpened: (opened) => {
      actions.setState({ opened });
    },
    checkPromotionCode: async () => {
      actions.setState({ loading: true, error: null });
      try {
        const coupon = await checkPromotionCode(state.promotionCode);
        actions.setState({
          loading: false,
        });
        setPromotionCode(coupon);
      } catch (e) {
        actions.setState({
          loading: false,
          error: e.response?.data?.message || e.message,
        });
      }
    },
    removePromotionCode: () => {
      actions.setState({
        promotionCode: '',
      });
      setPromotionCode(null);
    },
  };

  return { state, actions };
}
